export default __webpack_public_path__ + "static/media/instagram.8602dbe7.svg";